<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="d-flex justify-content-center">
                <img :src="logo"/>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login to <b>{{getDomain()}}</b> customer portal</h4>
                </div>

                <div>
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="User"
                    v-model="user"
                    class="w-full"
                  />

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                  />

                  <div class="flex flex-wrap justify-between my-5">
                  </div>
                  <vs-button type="border" :to="getRelativeLink('/register')">Register</vs-button>
                  <vs-button class="float-right" @click="checkLogin"
                    >Login</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: "",
      password: "",
      checkbox_remember_me: false,
      autofilled: false,
      logo: ""
    };
  },
  watch: {
    'user'() {
        this.autofilled = true;
     }
  },
  created() {
    if (this.$route.query.success) {
      this.alertUser("success", "User sucessfully created!", 3000, "icon-check-circle");
      this.user = this.$route.query.user.replace(this.getDomain() + ".", "");
    }
    this.getLogos(this.getDomain());
  },
  methods: {
    checkLogin() {
      if (this.user == "") {
        this.alertUser("danger", "Please enter your username");
      } else if (this.password == "") {
        this.alertUser("danger", "Please enter your password");
      } else {
        this.loginMyUser();
      }
    },
    async loginMyUser() {
      this.showLoadingSpinner();

      const urlWithParams = this.getDomain() === ''? new URL(
        process.env.VUE_APP_BASE_URL + "Rest/" + process.env.VUE_APP_LOGIN_PATH_USER 
      ) : new URL(
        process.env.VUE_APP_BASE_URL + "Rest/" + process.env.VUE_APP_LOGIN_PATH_CUSTOMER 
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      this.getDomain() === '' ? urlWithParams.searchParams.append("user",  this.user) :urlWithParams.searchParams.append("name",  this.getScopedUser(this.user));
      this.getDomain() === '' ? urlWithParams.searchParams.append("pwd", this.password) : urlWithParams.searchParams.append("password", this.password);
      
      const rawResponse = await fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include"
      });

      const response = await rawResponse.json();
      this.hideLoadingSpinner();
      
      if (response == 1) {
        this.alertUser("success", "Welcome to EzzyBills !!");
        this.$router.push({path:"/dashboard",query:{company:this.$route.query.company}});
      } else {
        this.alertUser("danger", "username/password is incorrect");
      }
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
</style>
